import React from "react";
import { WHATSAPP_LINK } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={WHATSAPP_LINK("Olá Cristina, gostaria de mais informações.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 left-6 z-30 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.787 2.715.787.32 0 .94-.064 1.246-.276.45-.293.738-.83.738-1.371 0-.143-.043-.286-.085-.42-.116-.215-1.69-.917-1.977-.917zM16.27 27.343a11.083 11.083 0 0 1-5.658-1.547L6.42 27.114l1.348-3.996a11.07 11.07 0 0 1-1.776-6.013c0-6.087 4.937-11.024 11.024-11.024 6.088 0 11.024 4.937 11.024 11.024.001 6.088-4.936 11.024-11.024 11.024Zm0-25.343C8.385 2 1.9 8.485 1.9 16.37c0 2.667.7 5.273 2.034 7.575L1.91 30.5l6.66-2.187a14.4 14.4 0 0 0 7.7 2.207c7.886 0 14.37-6.485 14.37-14.37C30.64 8.485 24.156 2 16.27 2Z" />
      </svg>
    </a>
  );
}
